module.exports = __webpack_public_path__ + "static/apple-icon-120x120-811e426a8e56c99ffe25ebf39d297030.png";